"use client";

import React, { Fragment, useEffect, useState } from "react";
import { SwiperSlide } from "swiper/react";
import { fetchVideoBanner } from '@/utils/helpers/helperFunctions';

import InfoSection from "@/components/aboutus/info-section";
// import TeamSection from "@/components/aboutus/team-section";
import PartnersSection from "@/components/aboutus/partners-section";
import RoadMapSection from "@/components/aboutus/roadmap-section";
import HomeSection from "@/components/aboutus/home-section";

import dynamic from 'next/dynamic';
const VideoBanner = dynamic(() => import('@/components/new/general/VideoBanner'), { ssr: false });

const AboutPage = () => {
  const [videoBannerURL, setVideoBannerURL] = useState(null);
  const [videoBannerMobileURL, setVideoBannerMobileURL] = useState(null);

  useEffect(() => {
    // Fetch the video banner for the about page
    fetchVideoBanner("about", setVideoBannerURL, setVideoBannerMobileURL);
  }, []);

  return (
    <Fragment>
      {/* <ToastContainer /> */}
      <VideoBanner>
        <SwiperSlide>
          <div
            className={`swiperSlideDiv relative w-full transition-transform duration-[600ms] ease-in-out`}
          >
            <video
              preload="auto"
              src={videoBannerURL || "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_about%2Fbanner%2Fdragon_banner_v3.mp4?alt=media&token=7c2c42cc-8f9c-4d30-96c5-3858d4861522"}
              autoPlay
              loop
              muted
              playsInline
              className="object-cover w-full h-full hidden md:block"
            />

            <video
              preload="auto"
              src={videoBannerMobileURL || "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_about%2Fbanner%2Fdragon_banner_v3.mp4?alt=media&token=7c2c42cc-8f9c-4d30-96c5-3858d4861522"}
              autoPlay
              loop
              muted
              playsInline
              className="object-cover w-full h-full md:hidden"
            />

            <div className="absolute !pr-8 !pl-8 xl:container  inset-x-[8%] 2xl:inset-x-[0%] block pt-4 pb-4 md:pb-8 text-left text-white  top-1/2 transform -translate-y-1/2">
              <h4 className="text-3xl font-bold text-white text-left gameHeader leading-tight">
                About
                <br />
                Us
              </h4>
            </div>
          </div>
        </SwiperSlide>
      </VideoBanner>

      <div className="grid grid-cols-1 gap-y-8 p-8">
        <InfoSection />
        <HomeSection />
        <RoadMapSection />
        {/* <div className="xl:container mt-8 videoContainerOnAboutUs">
          <video autoPlay={true} loop={true} className="w-full rounded-lg" src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_about%2Fss_ninja_sep.mp4?alt=media&token=b4b0de76-da38-4a18-8410-a7c6d6c0d638" />
        </div> */}
        {/* <TeamSection /> */}
        {/* <PartnersSection /> */}
      </div>
    </Fragment>
  );
};

export default AboutPage;
